import { registerPlugin } from '@capacitor/core';

import type { NativeBridgePlugin } from './definitions';

const NativeBridge = registerPlugin<NativeBridgePlugin>('NativeBridge', {
    web: () => import('./web').then(module => new module.OneSignalSPMWeb())
});

export * from './definitions';
export { NativeBridge };
